import { memo } from 'react'

import { css } from '@linaria/core'
import { styled } from '@linaria/react'
import { animated } from '@react-spring/web'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { zIndex } from 'components/designSystem/zIndex'

export const CardParent = styled.div`
  display: block;
  flex-grow: 1;
  position: absolute;
  left: 0;
  top: 0;
  touch-action: none;
  pointer-events: none;
  will-change: transform;
  backface-visibility: hidden;
  transform-origin: center bottom;
  cursor: grab;
  user-select: none;
  width: 100%;
  height: 100%;

  @media (min-width: ${breakpoints.mobile + 1}px) {
    z-index: ${zIndex.default};
  }
`

export const activeCardCss = css`
  pointer-events: auto;
  z-index: ${zIndex.default};
`

export const CardParentMemo = memo(animated(CardParent))
